export default "__VITE_ASSET__10478af4__"